/***************************************************************************/
"use client";
/***************************************************************************/

import { Button, ButtonIcon } from "@/client/components/ui/button";
import { Flex } from "@/client/components/ui/flex";
import {
  Result,
  ResultIcon,
  ResultMessage,
  ResultTitle,
} from "@/client/components/ui/result";
import { ArrowRightIcon } from "lucide-react";
import Link from "next/link";
import React from "react";
import { useTranslation } from "react-i18next";

const Message404: React.FC = () => {
  const { t: tH } = useTranslation("h");
  const { t: tError } = useTranslation("error");

  return (
    <Flex direction="vertical" gap="none" align-items="center">
      <Result variant="error" size="lg" className="my-[5vh]">
        <ResultIcon />
        <ResultTitle className="capitalize">{tError("404.title")}</ResultTitle>
        <ResultMessage>{tError("404.description")}</ResultMessage>
      </Result>
      <Link href="/">
        <Button className="w-40 justify-between">
          <span>{tH("home")}</span>
          <ButtonIcon>
            <ArrowRightIcon />
          </ButtonIcon>
        </Button>
      </Link>
    </Flex>
  );
};

export default Message404;
